import { SIDEBAR_COLLAPSE_BREAKPOINT } from '@lemontaps/lib/constants';
import { dispatchTypes } from '../actions';
import { Reducer } from 'redux';
import { AnyAction } from 'redux';

type UiState = {
  sidebarCollapsed: boolean;
  sidebarMyProfileCollapsed: boolean;
  sidebarAdminManagementCollapsed: boolean;
  sidebarSettingsCollapsed: boolean;
};

const initialState: UiState = {
  sidebarCollapsed: window.innerWidth < SIDEBAR_COLLAPSE_BREAKPOINT,
  sidebarMyProfileCollapsed: false,
  sidebarAdminManagementCollapsed: false,
  sidebarSettingsCollapsed: false,
};

const uiReducer: Reducer<UiState, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case dispatchTypes.UI.SET_SIDEBAR_COLLAPSED:
      return { ...state, sidebarCollapsed: action.sidebarCollapsed };
    case dispatchTypes.UI.SET_SIDEBAR_MY_PROFILE_COLLAPSED:
      return { ...state, sidebarMyProfileCollapsed: action.collapsed };
    case dispatchTypes.UI.SET_SIDEBAR_ADMIN_MANAGEMENT_COLLAPSED:
      return { ...state, sidebarAdminManagementCollapsed: action.collapsed };
    case dispatchTypes.UI.SET_SIDEBAR_SETTINGS_COLLAPSED:
      return { ...state, sidebarSettingsCollapsed: action.collapsed };
    default:
      return state;
  }
};

export default uiReducer;
